"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CuratedLiveSplitpaneWidgetDataSchema = void 0;
var zod_1 = require("zod");
exports.CuratedLiveSplitpaneWidgetDataSchema = zod_1.z.object({
    header: zod_1.z
        .object({
        title: zod_1.z.string(),
        subTitle: zod_1.z.string().optional(),
        icon: zod_1.z.string().url(),
        more: zod_1.z
            .object({
            title: zod_1.z.string(),
            action: zod_1.z.object({
                app: zod_1.z.string(),
                web: zod_1.z.string().url(),
            }),
            logMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
        })
            .nullish(),
    })
        .optional(),
    items: zod_1.z.array(zod_1.z.object({
        type: zod_1.z.enum(['LIVE', 'VOD', 'PREVIEW', 'CATCHUP']),
        title: zod_1.z.string(),
        image: zod_1.z.string().url(),
        action: zod_1.z.object({
            app: zod_1.z.string(),
            web: zod_1.z.string().url(),
        }),
        broadcastId: zod_1.z.string(),
        product: zod_1.z
            .object({
            title: zod_1.z.string(),
            image: zod_1.z.string().url(),
            priceTypeCode: zod_1.z.enum(['BASIC', 'TEXT', 'HIDE']),
            price: zod_1.z.string().optional(),
            discountRate: zod_1.z.string().optional(),
            saleEndDateTime: zod_1.z.string().optional(),
        })
            .optional(),
        videoPreview: zod_1.z
            .object({
            url: zod_1.z.string().url(),
            format: zod_1.z.enum(['M3U8', 'MP4']),
        })
            .optional(),
        duration: zod_1.z.string().optional(),
        badgeDesc: zod_1.z.string(),
        notificationMessage: zod_1.z.string().optional(),
        startDate: zod_1.z.string().optional(),
        startTime: zod_1.z.string().optional(),
        logMeta: zod_1.z.record(zod_1.z.unknown()),
    })),
    logMeta: zod_1.z.record(zod_1.z.unknown()),
});
